/* eslint-disable no-nested-ternary */
/* eslint-disable no-prototype-builtins */
import {
  Autocomplete, TextField, Box, Tooltip,
} from '@mui/material';
import React from 'react';
import SearchIcon from '@mui/icons-material/Search';
import DEFAULT_PRODUCT from 'Images/default_product.png';
import ListboxComponent from './AdapaterReactWindow';
import useStyles from './constants';

const RenderOption = ({ option, ...props }) => {
  const classes = useStyles();
  return (
    <Box sx={{ display: 'flex' }} {...props}>
      <div style={{ height: 60 }}>
        <img
            // eslint-disable-next-line no-return-assign
          onError={(e) => {
            e.target.onerror = null;
            e.target.src = DEFAULT_PRODUCT;
          }}
          className={classes.media}
          src={`https://media.copima.ma/${
            option?.img
              ? `products/${option?.img}`
              : option?.familyPicture
                ? `families/${option?.familyPicture}`
                : `brands/${option?.logoImage}`
          }`}
          alt={option?.fId || option?.name || option?.brand}
        />
      </div>
      <Tooltip
        title={
            option.reference
              ? `Produit: ${option.reference} ${option?.des}`
              : false || (option.familyLevel ? 'Famille :' : 'Marque :') + option.name
          }
      >
        <div>
          {option.reference && (
            <div>
              <span style={{ color: '#ACAFC6' }}>
                {option.reference}
                {' - '}
              </span>
              <span style={{ color: '#007BC6' }}>{option.bId}</span>
            </div>
          )}
          <div style={{ textOverflow: 'ellipsis', overflow: 'hidden', height: 20 }}>
            {option.reference
              ? option?.des
              : false || (option.familyLevel ? 'Famille :' : 'Marque :') + option.name}
          </div>
        </div>
      </Tooltip>
    </Box>
  );
};

const ProductSearch = ({ search, catalog, handleInputChange }) => {
  const classes = useStyles();
  return (
    <Box
      style={{
        display: 'flex',
        backgroundColor: '#FFF',
        alignItems: 'center',
        flexGrow: 1,
        flexShrink: 4,
        paddingLeft: 8,
        paddingRight: 6,
        borderRadius: 12,
        background: '#FFFFFF 0% 0% no-repeat padding-box',
        boxShadow: '0px 12px 26px #0000000D',
      }}
    >
      <SearchIcon style={{ color: 'gray' }} />
      <Autocomplete
        options={catalog}
        classes={{
          option: classes.option,
          inputRoot: classes.searchInput,
        }}
        onChange={(a, value) => handleInputChange(a, value)}
        value={search}
        size="small"
        fullWidth
        autoHighlight
        getOptionLabel={(option) => option.reference || option.name}
        ListboxComponent={ListboxComponent}
        renderOption={(props, option) => <RenderOption {...props} option={option} />}
        filterOptions={(options, v) => options
          .filter((option) => {
            if (option.hasOwnProperty('reference')) {
              return (
                option.reference?.toLowerCase().includes(v.inputValue.toLowerCase())
                            || option.des?.toLowerCase().includes(v.inputValue.toLowerCase())
                            || option.e?.toLowerCase().includes(v.inputValue.toLowerCase())
                            || option.rO?.toLowerCase().includes(v.inputValue.toLowerCase())
                            || option.fId?.toLowerCase().includes(v.inputValue.toLowerCase())
                            || option.bId?.toLowerCase().includes(v.inputValue.toLowerCase())
              );
            }
            return option.name?.toLowerCase().includes(v.inputValue.toLowerCase());
          })
          .slice(0, 5000)}
        renderInput={(params) => (
          <TextField
            {...params}
            label="Chercher"
            variant="outlined"
            inputProps={{
              ...params.inputProps,
              autoComplete: 'new-password', // disable autocomplete and autofill
            }}
                        // eslint-disable-next-line react/jsx-no-duplicate-props
            InputProps={{
              ...params.InputProps,
              classes: { notchedOutline: classes.notched },
            }}
            InputLabelProps={{
              classes: { root: classes.label },
            }}
          />
        )}
      />
    </Box>
  );
};

export default ProductSearch;
